import React from 'react'
import { ResearcherType } from './researcher'
import useManageProjectStore from '../../../../../../stores/manageProject/useManageProjectStore'

import useCheckPermission from '../../../../../../utilities/checkPermission'
import * as ResearcherOtherType from './researcherOtherType'
import constSubmittedType from '../../../../../../constants/submittedType'
import useAuthenStore from '../../../../../../stores/authen/authenStore'
import useIRB from '../../../../../../services/um/lookups/useIRB'

export default (props: ResearcherType) => {
    const { projectMode } = props
    const manageProjectStore = useManageProjectStore()

    const checkPermission = useCheckPermission()
    const { profile } = useAuthenStore()
    const { irb } = useIRB()

    const formValueRef = React.useRef<any>()

    const [initialData, setInitialData] = React.useState<any>()

    const isViewMode = checkPermission.chkProjectStepViewMode(
        manageProjectStore.projectData ? manageProjectStore.projectData : undefined,
    )

    React.useEffect(() => {
        const mode = projectMode
        if (mode === 'CREATE') {
            createInitialFormData()
        } else if (mode === 'EDIT') {
            editInitialFormData()
        }
    }, [manageProjectStore.projectData?.submittedID ?? null, irb ?? null])

    const createInitialFormData = () => {
        //กรณีเป็นผู้วิจัยภายนอกให้ default ค่าไว้เลย
        const isREC = { label: 'REC 1', value: '1' }
        const isFaculty = { label: 'ผู้วิจัยภายนอก', value: '7', irb: '1' }

        let initialData: ResearcherOtherType.InitialFormValueType = {
            isPhase: '1',
            langTH: true,
            isCertificatePaperList: '1',
            // academicPosition: `7`, //ไม่ระบุ
            faculty: profile.isCunet ? undefined : isFaculty,
            IRB: profile.isCunet ? undefined : isREC,
        }

        setInitialData(initialData)
    }

    const editInitialFormData = () => {
        let isRequestCertificatePager: string | null = null
        if (typeof manageProjectStore.projectData?.isRequestCertificatePager === 'boolean') {
            if (manageProjectStore.projectData?.isRequestCertificatePager === true) {
                isRequestCertificatePager = '1'
            } else {
                isRequestCertificatePager = '2'
            }
        }

        let initialData: ResearcherOtherType.InitialFormValueType = {
            academicPositionID: manageProjectStore.projectData?.academicPositionInfo?.value,
            // otherAcademicPosition: manageProjectStore.projectData?.academicPositionOther,
            otherAcademicPositionTH: manageProjectStore.projectData?.academicPositionOther_th,
            otherAcademicPositionEN: manageProjectStore.projectData?.academicPositionOther_en,
            email: manageProjectStore.projectData?.email,
            faculty: {
                label: `${manageProjectStore.projectData?.facultyInfo?.nameTH}`,
                value: `${manageProjectStore.projectData?.facultyInfo?.value}`,
            },
            fax: manageProjectStore.projectData?.fax,
            homePhone: manageProjectStore.projectData?.homePhone,
            irb: manageProjectStore.projectData?.irb,
            isDraft: manageProjectStore.projectData?.isDraft,
            mobilePhone: manageProjectStore.projectData?.mobilePhone,
            projectNameEN: manageProjectStore.projectData?.projectName_en,
            projectNameTH: manageProjectStore.projectData?.projectName_th,
            projectSubmitType: {
                label: `${manageProjectStore.projectData?.submitTypeInfo?.nameTH}`,
                value: `${manageProjectStore.projectData?.submitTypeInfo?.value}`,
            },
            nameEN: manageProjectStore.projectData?.researcherName_en,
            nameTH: manageProjectStore.projectData?.researcherName_th,
            //@ts-ignore
            researcherType:
                manageProjectStore.projectData?.researcherTypeInfo &&
                manageProjectStore.projectData?.researcherTypeInfo.value
                    ? {
                          label: `${manageProjectStore.projectData?.researcherTypeInfo?.nameTH}`,
                          value: `${manageProjectStore.projectData?.researcherTypeInfo?.value}`,
                      }
                    : null,
            educationLevel:
                manageProjectStore.projectData?.educationLevelInfo &&
                manageProjectStore.projectData?.educationLevelInfo.value
                    ? {
                          label: `${manageProjectStore.projectData?.educationLevelInfo?.nameTH}`,
                          value: `${manageProjectStore.projectData?.educationLevelInfo?.value}`,
                      }
                    : null,
            titleNameID: manageProjectStore.projectData?.titleNameInfo?.value,
            // otherTitleName: manageProjectStore.projectData?.titleNameOther,
            otherTitleNameTH: manageProjectStore.projectData?.titleNameOther_th,
            otherTitleNameEN: manageProjectStore.projectData?.titleNameOther_en,
            isPhase: manageProjectStore.projectData?.requestPhase ? '2' : '1', //`${manageProjectStore.projectData?.submitTypeInfo.value}`, //'2', // hardcode
            isTools: manageProjectStore.projectData?.isTools ? '2' : '1',
            IRB: irb.filter((itm) => parseInt(itm.value) === manageProjectStore.projectData?.irb)[0] || null,
            titleName: `${manageProjectStore.projectData?.titleNameInfo?.value}` || null,
            academicPosition: `${manageProjectStore.projectData?.academicPositionInfo?.value}` || null,
            langTH: manageProjectStore.projectData?.isLanguageTH ? manageProjectStore.projectData?.isLanguageTH : false,
            langEN: manageProjectStore.projectData?.isLanguageEN ? manageProjectStore.projectData?.isLanguageEN : false,
            isCertificatePaperList: isRequestCertificatePager,
            remarkFromAdmin: manageProjectStore.projectData?.verifyDocumentRemark || null,
            numPhase: manageProjectStore.projectData?.requestPhase,
            isDr: manageProjectStore.projectData?.isDr ? manageProjectStore.projectData?.isDr : false,
            researchProjectSummaryTH: manageProjectStore.projectData?.researchProjectSummary_th ?? null,
            researchProjectSummaryEN: manageProjectStore.projectData?.researchProjectSummary_en ?? null,
            projectAdvisor: manageProjectStore.projectData?.projectAdvisor ?? null,
            projectAdvisorEmail: manageProjectStore.projectData?.projectAdvisorEmail ?? null,
            projectAdvisorEmailReserve: manageProjectStore.projectData?.projectAdvisorEmailReserve ?? null,
            coResearcher: manageProjectStore.projectData?.coResearcher ?? [],
            documentAdditionalInfo: manageProjectStore.projectData?.documentAdditionalInfo ?? [],
        }

        setInitialData(initialData)
    }

    return {
        formValueRef,
        isViewMode,
        initialData: initialData,
        projectData: manageProjectStore.projectData,
        submittedType:
            manageProjectStore.projectData?.submitTypeInfo?.value ?? constSubmittedType.firstSubmitConsideration,
    }
}
